import {StyleSheet} from 'react-native';

import {cloudLight} from '/theme/color/on.color';
import {yellow, yellowLightest} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  backgroundColor: {
    backgroundColor: yellowLightest,
  },
  base: {
    marginBottom: 20,
    borderTopWidth: 5,
    borderColor: yellow,
    alignItems: 'flex-start',
  },
  badge: {
    backgroundColor: yellow,
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 3,
  },
  peopleListItem: {
    borderBottomWidth: 1,
    borderColor: cloudLight,
  },
  text: {
    paddingVertical: 20,
  },
});
